import { Directive } from '@angular/core';
import { NgpLabel } from 'ng-primitives/form-field';

@Directive({
  selector: '[sui-label]',
  standalone: true,
  hostDirectives: [NgpLabel],
})
export class SuiLabelDirective {}
